import React from 'react'
import '../assets/Album.css'

function Albums(props) {
  return (
    <>
      <div className="container overflowthis">
        <h5>{props.album.strAlbum} <b> ( {props.album.intYearReleased}</b> )</h5>
        <p dangerouslySetInnerHTML={{ __html: props.album.strDescriptionEN }} className=" bgcols rounded"></p>
      </div>
      <div
        className="cardAlbum m-1 containers"
        style={{
          backgroundImage: `url(${props.album.strAlbumThumb})`
        }}
      >
        <div className="overlay">
          <div className="col mt-4">
            <div className="col"><b>{props.album.strAlbum}</b></div>
            <div className="col"><b>{props.album.intYearReleased}</b></div>
            <div className="col"> International Rating : {props.album.intScore}</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Albums
